var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3ceff9250d1549eb21970704d751a42a5b005a45"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hype-next@studiothree"]={id:"3ceff9250d1549eb21970704d751a42a5b005a45"};
      